<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch05">
<a id="page6">
<div class="chapterHead">
<h2 class="chapterTitle"> </h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords"><span class="bold">I should have shared this earlier,</span></span> but, well, I’m the Universe and I’ve been busy.</p>
<p class="spaceBreak"> </p>
<p class="paraCenter">In the beginning, long before there were even beaches to walk along, clouds to float upon, or stars to wish on, I dreamed of you and your happiness.</p>
<p class="spaceBreak"> </p>
<p class="paraCenter">And everything that has ever been added since was to that end.</p>
<p class="spaceBreak"> </p>
<p class="paraCenter"><em class="italic">See? You are so much more to me than just pretty planet decoration.</em></p>
</div>
</a></div><a id="page6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_ch05.vue?2a2a715a